// extracted by css-extract-rspack-plugin
export default {"loyaltySurveyModalSubheader":"loyalty-survey-modal-subheader--npTo3s2B8gnRLSxb","stepHeaderTitle":"step-header-title--lGaSEvypQP8swvHj"};